import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FmnWatermark } from "../FmnWatermark";

const FADE = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" }, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } };

export function Problem() {
    const { t } = useTranslation();
    return (
        <section className="relative py-32 px-6 bg-white overflow-hidden" data-testid="problem-section" id="problem">
            <FmnWatermark position="left" size={780} opacity={0.05} rotate={10} />
            <div className="max-w-7xl mx-auto">
                <motion.p {...FADE} className="font-sans text-xs uppercase tracking-[0.3em] text-[#6B7DB8] font-semibold text-center mb-6">
                    {t("problem.eyebrow")}
                </motion.p>
                <motion.h2 {...FADE} transition={{ ...FADE.transition, delay: 0.1 }} className="font-serif text-4xl sm:text-5xl lg:text-6xl text-center text-[#2D2B2A] max-w-3xl mx-auto leading-tight">
                    {t("problem.headline")}
                </motion.h2>

                <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-stretch">
                    <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.15 }} className="md:col-span-4 rounded-3xl bg-[#F4F6FB] p-10 flex flex-col justify-center" data-testid="problem-stat-1">
                        <p className="font-serif text-6xl lg:text-7xl text-[#4A5A95] tracking-tight">{t("problem.stat_1_value")}</p>
                        <p className="mt-3 text-[#5C5A59] leading-relaxed">{t("problem.stat_1_label")}</p>
                    </motion.div>
                    <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.25 }} className="md:col-span-4 rounded-3xl bg-[#F4F6FB] p-10 flex flex-col justify-center" data-testid="problem-stat-2">
                        <p className="font-serif text-6xl lg:text-7xl text-[#4A5A95] tracking-tight">{t("problem.stat_2_value")}</p>
                        <p className="mt-3 text-[#5C5A59] leading-relaxed">{t("problem.stat_2_label")}</p>
                    </motion.div>
                    <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.35 }} className="md:col-span-4 rounded-3xl bg-gradient-to-br from-[#8C9ECB] to-[#6B7DB8] text-white p-10 flex flex-col justify-center" data-testid="problem-stat-3">
                        <p className="font-serif text-6xl lg:text-7xl tracking-tight">{t("problem.stat_3_value")}</p>
                        <p className="mt-3 text-white/85 leading-relaxed">{t("problem.stat_3_label")}</p>
                    </motion.div>
                </div>

                <motion.div {...FADE} transition={{ ...FADE.transition, delay: 0.45 }} className="mt-20 max-w-3xl mx-auto text-center" data-testid="problem-body">
                    <p className="text-xl text-[#2D2B2A] font-serif italic leading-relaxed">
                        {t("problem.quote")}
                    </p>
                    <p className="mt-6 text-[#5C5A59] leading-relaxed">
                        {t("problem.body")}
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
